import { useCallback } from 'react';

// Helper function to format cycle count ID for display
export const getDisplayID = (id) => {
    return `CC${String(id).padStart(6, '0')}`;
};

// Custom hook for location-related helpers
export const useLocationHelpers = (currentUser, cycleCount) => {
    const getLocationName = useCallback(() => {
        if (cycleCount?.location?.name) {
            return cycleCount.location.name;
        }
        const location = currentUser?.locations?.find((loc) => loc.locationId === cycleCount?.locationId);
        return location?.name || 'N/A';
    }, [currentUser, cycleCount]);

    const getLocationAddress = useCallback(() => {
        if (cycleCount?.location) {
            const lines = [];
            if (cycleCount.location.address1) lines.push(cycleCount.location.address1);
            if (cycleCount.location.address2) lines.push(cycleCount.location.address2);
            const cityLine = [cycleCount.location.city, cycleCount.location.province, cycleCount.location.zip].filter(Boolean).join(', ');
            if (cityLine) lines.push(cityLine);
            return lines;
        }
        const location = currentUser?.locations?.find((loc) => loc.locationId === cycleCount?.locationId);
        if (!location) return [];
        const lines = [];
        if (location.address1) lines.push(location.address1);
        if (location.address2) lines.push(location.address2);
        const cityLine = [location.city, location.province, location.zip].filter(Boolean).join(', ');
        if (cityLine) lines.push(cityLine);
        return lines;
    }, [currentUser, cycleCount]);

    const getLocationPhone = useCallback(() => {
        if (cycleCount?.location?.phone) {
            return cycleCount.location.phone;
        }
        const location = currentUser?.locations?.find((loc) => loc.locationId === cycleCount?.locationId);
        return location?.phone || 'N/A';
    }, [currentUser, cycleCount]);

    return { getLocationName, getLocationAddress, getLocationPhone };
};

export const FILTER_STORAGE_KEY = 'cycleCountsFilters';

/**
 * Load filters from session storage
 * @returns {object|null} filters or null if not found
 */
export const loadFiltersFromSession = () => {
    try {
        const raw = sessionStorage.getItem(FILTER_STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (err) {
        console.error('Error loading filters from sessionStorage:', err);
        return null;
    }
};

/**
 * Save filters to session storage
 * @param {object} filters
 * filters: { queryValue: any; statusFilter: any; typeFilter: any; storeFilter: any; sortSelected: any; page: any; }
 */
export const saveFiltersToSession = (filters) => {
    try {
        sessionStorage.setItem(FILTER_STORAGE_KEY, JSON.stringify(filters));
    } catch (err) {
        console.error('Error saving filters to sessionStorage:', err);
    }
};
